module.exports = "/_next/static/images/portfolio-d3ab06a5e840fa7ec4422203b4e86156.svg";